export default class BarcodeRangeCreateRequest {
  /**
   *
   * @param {number[]} lineIds Les identifiants des lignes
   * @param {number} start Le premier code barre de la plage
   * @param {number} number Le nombre de codes barres à créer
   * @param {Number} appointmentId L'identifiant du rendez-vous
   * @param {Number} immediateTaggingId L'identifiant de l'étiquetage imémédiat
   * @param {Number} stakeholderId L'identifiant du stakeholder
   */
  constructor({
                start,
                number = 1,
                lineIds = [],
                appointmentId = null,
                immediateTaggingId = null,
                stakeholderId = null,
              }) {
    this.lineIds = lineIds;
    this.start = start;
    this.number = number;
    this.appointmentId = appointmentId;
    this.immediateTaggingId = immediateTaggingId;
    this.stakeholderId = stakeholderId;
  }
}
